import { Base2Presenter } from "core/presenter";
import { InvoiceAccountantAreaRepository } from "core/repository";
import _ from "lodash";

class InvoiceInfoPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      invoice: {
        _id: "",
        serie_number: "",
        last_nfce_number: ""
      },
      inactiveSeries: [],
      isCreated: false
    };
  }

  async onStart() {
    this.enqueue({ loading: true });
    const currentUser = await this.mRuntime.get("currentUser");
    const resultAll = await InvoiceAccountantAreaRepository.getAllSeries(
      currentUser.company_uuid
    );
    const allSeries = resultAll.data;
    const inactiveSeries = allSeries.filter(s => s.active === false);
    const data = allSeries.find(s => s.active === true);
    const { success } = resultAll;
    if (success) {
      if (data) {
        if (
          _.isNumber(data.serie_number) &&
          _.isNumber(data.last_nfce_number)
        ) {
          this.enqueue({
            invoice: data,
            inactiveSeries
          });
        }
        this.enqueue({
          isCreated:
            _.isNumber(data.serie_number) && _.isNumber(data.last_nfce_number)
        });
      } else if (inactiveSeries) {
        this.enqueue({
          inactiveSeries
        });
      }
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não foi possível buscar as informações de Nota Fiscal. Por favor, tente novamente mais tarde ou entre em contato com o suporte."
      });
    }

    this.enqueue({ loading: false });
  }

  onChange(field, value) {
    this.enqueue(vm => ({
      invoice: {
        ...vm.invoice,
        [field]: value
      }
    }));
  }

  handleClick() {
    if (!this.viewModel.isCreated) {
      return this.submitInvoiceData();
    }

    return this.deleteInvoiceData();
  }

  async submitInvoiceData() {
    this.enqueue({ loading: true });

    const { serie_number, last_nfce_number } = this.viewModel.invoice;

    const result = await InvoiceAccountantAreaRepository.create({
      serie_number: Number(serie_number),
      last_nfce_number: Number(last_nfce_number)
    });

    if (result.success) {
      this.enqueue({
        isCreated: true,
        invoice: {
          _id: result.data.data._id,
          serie_number: result.data.data.serie_number,
          last_nfce_number: result.data.data.last_nfce_number
        }
      });
      this.sendNotification({
        type: "success",
        content: "Alterações salvas com sucesso!"
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não foi possível salvar as informações de Nota Fiscal. Por favor, tente novamente mais tarde ou entre em contato com o suporte."
      });
    }

    this.enqueue({ loading: false });
  }

  async onActivateSerie(serie) {
    this.sendNotification({
      type: "confirmation",
      title: "Somente uma série pode estar ativa",
      content: `Ao ativar a série ${serie.serie_number}, a série atual será desativada. Tem certeza que deseja prosseguir?`,
      actions: [
        {
          label: "Voltar"
        },
        {
          label: `Sim, quero ativar a série ${serie.serie_number}`,
          type: "accent",
          callback: () => this.doActivate(serie)
        }
      ]
    });
  }

  async doActivate(serie) {
    try {
      this.enqueue({ loading: true });
      await InvoiceAccountantAreaRepository.activate(serie._id);
      this.sendNotification({
        type: "success",
        content: "Alterações salvas com sucesso!"
      });
      const inactiveSeries = this.viewModel.inactiveSeries.filter(
        s => s._id !== serie._id
      );
      if (this.viewModel.isCreated) {
        inactiveSeries.push(this.viewModel.invoice);
      }

      this.enqueue({
        invoice: serie,
        inactiveSeries,
        isCreated: true,
        loading: false
      });
    } catch (err) {}
  }

  async deleteInvoiceData() {
    this.enqueue({ loading: true });
    try {
      const { invoice, inactiveSeries } = this.viewModel;
      const { _id } = invoice;
      const result = await InvoiceAccountantAreaRepository.deactivate(_id);
      if (result.success) {
        inactiveSeries.push(this.viewModel.invoice);
        this.enqueue({
          isCreated: false,
          invoice: {
            _id: "",
            serie_number: "",
            last_nfce_number: "",
            inactiveSeries
          }
        });
      } else {
        this.sendNotification({
          type: "error",
          title: "Oops...",
          content:
            "Não foi possível remover as informações de Nota Fiscal. Por favor, tente novamente mais tarde ou entre em contato com o suporte."
        });
      }
    } catch (error) {}

    this.enqueue({ loading: false });
  }
}

export default InvoiceInfoPresenter;



// WEBPACK FOOTER //
// ./src/components/app/accountant-area/invoice-info/presenter.js